import {CurrentTaskAnswer, TaskFormField} from '../../../../../types';
import {TaskField} from '../../../../../../../constants/tasks';

type InitialValuesParams = {
  id: number,
  type: TaskField,
  answers: CurrentTaskAnswer[]
}

const DEFAULT_SENTIMENT_SLIDER = '3';

const getInitialValueByType = ({
  id,
  type,
  answers
}: InitialValuesParams) => {
  const {answer} = answers
      ?.find(({formFieldId}) => id === formFieldId) || {answer: null};

  if (type === TaskField.SENTIMENT_SLIDER) {
    return answer ? answer : DEFAULT_SENTIMENT_SLIDER;
  }

  if (type === TaskField.EMPLOYEE_STUCKS_CHECKLIST) {
    return answer ? answer.split(',') : [];
  }

  return '';
};

export const getInitialValues = (
    questions: Nullable<TaskFormField[]> = [],
    answers: CurrentTaskAnswer[] = []
) => {
  if (!questions?.length) {
    return {};
  }

  return questions?.reduce((acc, {id, type}) => {
    acc[id] = getInitialValueByType({id, type, answers});

    return acc;
  }, {});
};
